import getMeta from './utils/get-meta/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { MetaGetter } from './utils/get-meta';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default getMeta;
